import { BaseListing } from "../../common/BaseListing";
import React from "react";
import { DateHelper } from "../../../common/Helpers";
import _ from "lodash";
import { Classify, MovieFormat } from "../../../constants/MovieConstants";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";

export class MovieReleaseMediaListing extends BaseListing {
  constructor() {
    super();
    this.state = {
      search: "",
    };
  }

  getNavigationSettings = () => {
    return new NavigationSettings({
      parentModule: new NavigationItem({
        identifier: "movies",
        name: "Movies",
      }),
      activeModule: new NavigationItem({
        identifier: "movie_release_medias",
        name: "Movie Media",
      }),
    });
  };

  getApiPath = () => "/api/v1/movie_releases";

  getDefaultSort = () => "-UpdatedOn";

  injectSearchTerm(queryParameters, searchBy) {
    const { search } = this.state;
    const request = {};
    if (!_.isEmpty(search)) {
      request.search = search;
    }
    return super.injectSearchTerm(queryParameters, request);
  }

  onRowClick = (id) => {
    this.props.history.push(`movie_release_medias/${id}`);
  };

  generateTableContent() {
    return (
      <>
        <thead>
          <tr>
            <th onClick={this.onColumnClick}>
              Primary Title
              <i
                className="fas fa-sort-alpha-down"
                id="PrimaryTitle"
                onClick={this.toggleSort}
              />
            </th>
            <th>Secondary Title</th>
            <th onClick={this.onColumnClick}>
              Movie Format
              <i
                className="fas fa-sort-alpha-down"
                id="Format"
                onClick={this.toggleSort}
              />
            </th>
            <th>Movie Rating</th>
            <th onClick={this.onColumnClick}>
              Updated On
              <i
                className="fas fa-sort-alpha-down"
                id="UpdatedOn"
                onClick={this.toggleSort}
              />
            </th>
          </tr>
        </thead>
        <tbody id="data">
          {!_.isNil(this.state.data)
            ? this.state.data.map((item) => {
                return (
                  <tr key={item.id} onClick={() => this.onRowClick(item.id)}>
                    <td>{item.primaryTitle}</td>
                    <td>{item.secondaryTitle}</td>
                    <td>{MovieFormat.getName(item.format)}</td>
                    <td>{Classify.getName(item.classify)}</td>
                    <td className="datetime">
                      {DateHelper.formatDateTimeString(item.updatedOn)}
                    </td>
                  </tr>
                );
              })
            : null}
        </tbody>
      </>
    );
  }

  generateTableFilter() {
    const { search } = this.state;
    return (
      <div className="row mb-3">
        <div className="col-md-6 input-group ml-auto">
          <input
            type="text"
            id="input1-group2"
            name="search"
            placeholder="Search"
            className="form-control"
            onKeyDown={this.onKeyDownSearchInput}
            onChange={this.onTextBoxChange}
            value={search}
          />
          <div className="input-group-btn">
            <button className="btn btn-primary" onClick={this.search}>
              <i className="fa fa-search" aria-hidden="true" /> Search
            </button>
          </div>
        </div>
      </div>
    );
  }

  onTextBoxChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
}
